// extracted by mini-css-extract-plugin
export default {"wrapper":"CodeInput_wrapper__4zcpm"};